import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser, API } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");
    if (!sessionId) { navigate("/auth"); return; }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data);
        const dest = data.favorite_sport ? "/app" : "/onboarding";
        navigate(dest, { state: { user: data }, replace: true });
      } catch {
        navigate("/auth", { replace: true });
      }
    })();
  }, [navigate, setUser, API]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="text-slate-400 font-display text-2xl uppercase tracking-wide animate-pulse" data-testid="auth-callback-loading">
        Signing you in...
      </div>
    </div>
  );
}
